import React from "react";
import { makeStyles, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearTokens } from "../../utils/tokens";
import { logoutUser } from "../../redux/modules/userSlice";
import { REVOKED_ACCOUNT_MESSAGE } from "../../utils/authErrors";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: 24,
    textAlign: "center",
    backgroundColor: "#121212",
    color: "#ffffff",
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 12,
    color: "#FE5A97",
  },
  message: {
    fontSize: 16,
    lineHeight: 1.5,
    maxWidth: 420,
    marginBottom: 28,
    color: "#C7CBD1",
  },
  button: {
    backgroundColor: "#FE5A97",
    color: "#fff",
    padding: "10px 24px",
    "&:hover": {
      backgroundColor: "#d95aab",
    },
  },
}));

type Props = {
  message?: string;
};

export default function AccountRevokedScreen({
  message = REVOKED_ACCOUNT_MESSAGE,
}: Props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const handleBackToLogin = () => {
    clearTokens();
    dispatch(logoutUser());
    localStorage.removeItem("user");
    history.replace("/login");
  };

  return (
    <div className={classes.container}>
      <h1 className={classes.title}>Account revoked</h1>
      <p className={classes.message}>
        {message}. Please contact support if you believe this is a mistake.
      </p>
      <Button
        className={classes.button}
        variant="contained"
        onClick={handleBackToLogin}
      >
        Back to login
      </Button>
    </div>
  );
}
